import KeenSlider from 'keen-slider'
import { keyboard, dots, arrows, autoPlay } from './slider-plugins'

const initSlider = () => {
  const sliders = document.querySelectorAll('.keen-slider')
  const animation = { duration: 20000, easing: (t) => t }

  if (!sliders?.length) return

  sliders.forEach((slider) => {
    const config = {
      drag: slider.classList.contains('slider--grab'),
      loop: slider.classList.contains('slider--loop'),
      mode: slider.classList.contains('slider--snap') ? 'snap' : 'free',
      renderMode: 'performance',

      slides: {
        perView: slider.id === 'js-text-slider' ? 'auto' : slider.dataset.cols,
        spacing: 32,
      },
    }

    if (slider.id === 'js-text-slider') {
      config.created = (s) => s.moveToIdx(5, true, animation)
      config.updated = (s) => s.moveToIdx(s.track.details.abs + 5, true, animation)
      config.animationEnded = (s) => s.moveToIdx(s.track.details.abs + 5, true, animation)
    }

    const plugins = [keyboard]

    if (slider.classList.contains('slider--markers')) plugins.push(dots)

    if (slider.classList.contains('slider--arrows')) plugins.push(arrows)

    if (slider.classList.contains('slider--auto')) plugins.push(autoPlay)

    new KeenSlider(slider, config, plugins)
  })
}

initSlider()
